type Options = {
  localeWeekdays: string[]
  localeWeekdaysShort: string[]
  use: 'full' | 'short'
  minMatchLength?: number
}

export const formatWeekdayTime = (input: string, options: Options): string | null => {
  const { localeWeekdays, localeWeekdaysShort, use, minMatchLength = 2 } = options
  if (
    !localeWeekdays ||
    localeWeekdays.length !== 7 ||
    !localeWeekdaysShort ||
    localeWeekdaysShort.length !== 7
  ) {
    throw new Error('localeWeekdays must contain exactly 7 values for the days of the week.')
  }

  // Определяем максимальную длину введенного, после которой уже не будет совпадения
  const maxMatchLength = localeWeekdays.reduce(
    (acc, val) => (acc > val.length ? acc : val.length),
    0,
  )

  // Часть введенного, отвечающая за день недели
  const inputWeekdayEntered = input.toLocaleLowerCase().replace(/[^a-zа-я]/g, '')
  // Форматированный день недели
  const formattedDay = (() => {
    if (/^[1-7]{1}$/.test(input)) {
      return use === 'full'
        ? localeWeekdays[parseInt(input, 10) - 1]
        : localeWeekdaysShort[parseInt(input, 10) - 1]
    }
    if (inputWeekdayEntered.length >= minMatchLength) {
      const weekdays = [
        ...localeWeekdays.map((d) => d.toLocaleLowerCase()),
        ...localeWeekdaysShort.map((d) => d.toLocaleLowerCase()),
      ]
      const index = weekdays.findIndex((d) => d.startsWith(inputWeekdayEntered))
      const weekdayIndex = index > 6 ? index - 7 : index
      if (weekdayIndex !== -1) {
        return use === 'full' ? localeWeekdays[weekdayIndex] : localeWeekdaysShort[weekdayIndex]
      }
      return inputWeekdayEntered.length >= maxMatchLength || /\s/.test(input)
        ? ''
        : inputWeekdayEntered
    }
    return inputWeekdayEntered
  })()

  // Если введена только одна цифра от 1 до 7 то выводим соответствующий день недели
  if (/^[1-7]{1}$/.test(input)) return formattedDay

  // Поиск времени (может быть частично введено)
  const timeRegex = /(\d{1,2}):?(\d{0,2})?/
  const timeMatch = input.match(timeRegex)

  let formattedTime = ''
  if (timeMatch) {
    let [, hours, minutes] = timeMatch

    if (hours.length === 1 && input.match(/^\d:/)) {
      // Если введена одна цифра и сразу после нее идет ":", добавляем 0 перед часами
      hours = '0' + hours
    }

    if (minutes === undefined && hours.length === 2 && !input.includes(':')) {
      // Если введены две цифры без ':', добавляем ':' в конец
      formattedTime = hours + ':'
    } else {
      formattedTime = hours + (minutes ? ':' + minutes : '')
    }
  }

  return `${formattedDay} ${formattedTime}`.trim()
}
